import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Checkbox } from 'antd';
import { useIntl } from 'react-intl';

const StyledCheckboxDiv = styled.div`
  margin: 20px 0;
`;

const useDoNotShow = (key) => {
  const intl = useIntl();
  const dontShowItems = localStorage.getItem('dontShowItems') || '[]';
  const parsedItems = JSON.parse(dontShowItems) || [];
  const doNotShow = parsedItems?.find(i => i === key);

  const checkbox = useMemo(() =>
    <StyledCheckboxDiv>
      <Checkbox
        onChange={(e) => {
          if (e.target.checked) {
            localStorage.setItem('dontShowItems', JSON.stringify([...parsedItems, key]));
          } else {
            localStorage.setItem(
              'dontShowItems',
              JSON.stringify(parsedItems?.filter(d => d !== key)),
            );
          }
        }}
      >
        {intl.formatMessage({ id: 'ticket.smart_actions.INFO_RADIO_TEXT' })}
      </Checkbox>
    </StyledCheckboxDiv>,
    []);

  return [doNotShow, checkbox];
};

export default useDoNotShow;
